import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useScreenWidth } from "hooks/useScreenWidth";
import { QueryParamProvider } from "providers/queryParams";
import { Outlet } from "react-router-dom";
import { CspViolationReporter } from "./components/CspViolationReporter";
import { PrevNextNavigationProvider } from "./components/PrevNextNavigation";
import { BreadcrumbProvider } from "./providers/breadcrumbs";
import { useEncampTheme } from "./theme";
import { SharedGoogleMapsProvider } from "./components/SharedGoogleMapsProvider";
import { CommandPaletteProvider } from "./components/CommandPaletteProvider";
import { MinimizedDialogsProvider } from "./providers/minimizedDialogs";
import { DocumentReviewProvider } from "./providers/documentReview";
import { DocumentAIAnalysisProvider } from "./providers/documentAIAnalysis";
import { MinimizedDialogsToolbar } from "./components/MinimizedDialogs/MinimizedDialogsToolbar";

export function App() {
  const { screenMaxWidth } = useScreenWidth();

  const encampTheme = useEncampTheme();

  return (
    <QueryParamProvider>
      <CspViolationReporter />
      <ThemeProvider theme={encampTheme}>
        <CssBaseline />
        <MinimizedDialogsProvider>
          <DocumentReviewProvider>
            <DocumentAIAnalysisProvider>
              <CommandPaletteProvider>
                <PrevNextNavigationProvider>
                  <BreadcrumbProvider>
                    <SharedGoogleMapsProvider>
                      <Box
                        sx={screenMaxWidth ? { maxWidth: screenMaxWidth } : {}}
                      >
                        <Outlet />
                      </Box>
                      <MinimizedDialogsToolbar />
                    </SharedGoogleMapsProvider>
                  </BreadcrumbProvider>
                </PrevNextNavigationProvider>
              </CommandPaletteProvider>
            </DocumentAIAnalysisProvider>
          </DocumentReviewProvider>
        </MinimizedDialogsProvider>
      </ThemeProvider>
    </QueryParamProvider>
  );
}
